import { useRef, useState } from 'react';
import { ReportingContainerBaseConfig } from '../../../../../base';
import { EnumElementController } from './enumElementInterface';
import { EnumElementContainerProps } from './enumElementProps';

export function createEnumElementContainer(
    config: ReportingContainerBaseConfig,
    controller: EnumElementController
): React.FC<EnumElementContainerProps> {
    return ({ as: View, ...containerProps }) => {
        const containerRef = useRef<HTMLDivElement>(null);
        const [editing, setEditing] = useState(false);
        const props = controller.useProps(containerProps.item, {
            containerRef: containerRef,
            isEditing: editing,
            value: containerProps.value,
            onChange(value) {
                setEditing(false);
                containerProps.onChange(value);
            },
            onOptionCreate(option) {
                console.log('onOptionCreate', option);
            },
            onBlur() {
                setEditing(false);
            },
            onEdit() {
                setEditing(true);
            },
        });
        return <View {...props} />;
    };
}
